<template>
  <div style="position: relative;">
    <v-data-table :headers="headers" :items="groupList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <td @click.stop="open_edit_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.name }}</td>
        <td @click.stop="open_edit_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.uuid }}</td>
        <td @click.stop="open_edit_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.state }}</td>
      </template>
    </v-data-table>
    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add_group"><v-icon>add</v-icon></v-btn>

    <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; width: 300px;">
      <v-text-field color="deep-orange" v-model="search_text" ref="search_field" prepend-icon="search" hide-details single-line></v-text-field>
    </v-toolbar>

  </div>
</template>

<script>
export default {
  props: ['type'],
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Uuid', value: 'uuid', align: 'left' },
        { text: 'State', value: 'state', align: 'left' }
      ],
      pagination: {
        sortBy: 'name',
        descending: true,
        rowsPerPage: 25
      },
      search_text: ""
    }
  },
  computed: {
    groupList () {
      var ret = Object.values(this.$store.state.all_groups);
      var search = (this.search_text || "").toLowerCase();
      if (search.length > 0) {
        ret = _.filter(ret, function(group) {
          ret = false;
          if (group.name.toLowerCase().includes(search)) ret = true;
          if (group.uuid.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }
      return ret;
    }
  },
  mounted () {
    this.$refs.search_field.focus();
  },
  methods: {
    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    open_add_group () {
      this.$router.push("/settings/groups/new")
    },
    open_edit_group (uuid) {
      this.$router.push("/settings/groups/edit/"+uuid)
    }
  }
}
</script>
